import React from "react";
import Framework from "@beardeddevops/react.framework";
import {Types} from "components";

class HelpDeskRescheduleFourth extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Tickets_Financials._name);
		this.state.expected_labor = null;
		this.state.labor_amount = null;
		this.state.id = props.id;
		this.read = 'GET_HELPDESK_RESCHEDULE_FOURTH';
	}

	render() {
		return (
			<fieldset>
				{this.state.expected_labor !== null && <div className={'row'}>
					<div className={'col-12'}>
						<div className="form-group">
							Can this user be rescheduled for their last appointment?&nbsp;&nbsp;
							{this.state.expected_labor === 'none' ?
								<span> YES.</span>
								: <>
									<span> NO.</span>
									<br/>
									<br/>
									<span> Current Labor Total: {this.state.labor_amount}. Additional Labor Required: {this.state.expected_labor}</span>
								</>
							}
						</div>
					</div>
				</div>}
			</fieldset>
		)
	}
}

export default Framework.Components.withRootState(HelpDeskRescheduleFourth);
